const setLocalStorage = (key, value) => {
	try {
		localStorage.setItem(key, value);
	} catch (error) {
		console.error(error);
	}
};

export default setLocalStorage;
